<template>
    <div>
        <filters-loading v-if="filtersLoading" />
        <section
            v-else
            class="filters-panel filters-panel--border-bottom row filters-panel__row"
        >
            <div class="col-lg-5 filters-panel__col d-flex d-lg-block">
                <div class="filters-panel-search">
                    <label
                        class="filters-panel-search__label"
                        for="filters-panel-search__input"
                        @click="onSearch"
                    ></label>
                    <input
                        id="filters-panel-search__input"
                        v-model="searchText"
                        type="text"
                        name=""
                        class="app-input filters-panel-search__input"
                        placeholder="Поиск"
                        @keyup.enter="onSearch"
                    />
                    <label
                        v-if="searchText"
                        class="filters-panel-search__clear"
                        for="filters-panel-search__input"
                        @click="onClearSearch"
                    ></label>
                </div>
                <div class="position-relative d-lg-none">
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default filters-panel__mob-btn d-lg-none ml-3 js-open-mob-filters"
                        @click="level1mFilter = true"
                    >
                        Фильтры
                    </button>
                    <div
                        v-if="appliedFiltersCount"
                        class="mobile-filter__selected-label mobile-filter__selected-label--circle"
                    >
                        {{ appliedFiltersCount }}
                    </div>
                </div>
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.categories.value"
                    :options="categories"
                    key-value="CategoryID"
                    key-title="Name"
                    select-title="Категория:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('categories', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.types.value"
                    :options="typesByCategories"
                    key-value="TypeID"
                    key-title="Name"
                    select-title="Вид изделия:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('types', $event)"
                />
            </div>
            <div class="col-lg-2 filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.materials.value"
                    :options="materials"
                    key-value="MaterialID"
                    key-title="Name"
                    select-title="Материал:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('materials', $event)"
                />
            </div>

            <div class="filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.finenesses.value"
                    :options="finenessesByMaterials"
                    key-value="FinenessID"
                    key-title="Value"
                    select-title="Проба:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('finenesses', $event)"
                />
            </div>
            <div class="col-lg-2  filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.insertMaterials.value"
                    :options="insertMaterials"
                    key-value="MaterialID"
                    key-title="Name"
                    select-title="Материал вставки:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('insertMaterials', $event)"
                />
            </div>
            <div class="filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.collections.value"
                    :options="collectionsByBrand"
                    key-value="CollectionID"
                    key-title="Name"
                    select-title="Коллекция:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('collections', $event)"
                />
            </div>
            <div class="filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.brands.value"
                    :options="brands"
                    key-value="BrandID"
                    key-title="BrandName"
                    select-title="Бренд:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('brands', $event)"
                />
            </div>
            <div class="filters-panel__col d-none d-lg-block">
                <select-picker
                    :current-value="filter.genders.value"
                    :options="genders"
                    key-value="id"
                    key-title="title"
                    select-title="Для кого:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('genders', $event)"
                />
            </div>
            <div
                v-if="isCategoryDecoration"
                class="filters-panel__col d-none d-lg-block"
            >
                <select-picker
                    :current-value="filter.garnitures.value"
                    :options="garnituresOpts"
                    key-value="id"
                    key-title="title"
                    select-title="Гарнитур:"
                    select-width="100%"
                    :is-multiple="true"
                    :classes="['select']"
                    @onChange="onSelectPickerChange('garnitures', $event)"
                />
            </div>
            <div class="filters-panel__col d-none d-lg-block">
                <button
                    v-if="!isAllDefaultValues"
                    type="button"
                    class="cabinet-btn cabinet-btn--default"
                    @click="resetFilters()"
                >
                    Сбросить
                </button>
            </div>
        </section>

        <section>
            <div
                class="flex flex-column flex-justify-sb mobile-filter"
                :class="{ 'mobile-filter--open': level1mFilter }"
            >
                <div class="mobile-filter__wrap">
                    <div
                        class="flex flex-justify-sb flex-align-center mobile-filter__header"
                    >
                        <div class="h3 mobile-filter__title">
                            Фильтр
                            <span class="mobile-filter__selected-count"></span>
                        </div>
                        <button
                            type="button"
                            class="mobile-filter__close-btn"
                            @click="level1mFilter = false"
                        ></button>
                    </div>

                    <ul class="mobile-filter__list">
                        <li
                            v-for="(filterKey, i) in Object.keys(filter)"
                            :key="i"
                            class="mobile-filter__list-item"
                            @click="setlevel2mFilters(filterKey)"
                        >
                            <div class="d-flex justify-content-between">
                                {{ filter[filterKey].title }}
                                <div
                                    v-if="!filter[filterKey].isDefault"
                                    class="mobile-filter__selected-label d-flex align-items-center"
                                >
                                    {{ filter[filterKey].value.length }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="d-flex p-3 mobile-filter__footer">
                    <button
                        type="button"
                        class="cabinet-btn mr-3"
                        @click="level1mFilter = false"
                    >
                        Показать
                    </button>
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        @click="resetFilters()"
                    >
                        Сбросить
                    </button>
                </div>
            </div>

            <div
                v-if="!!level2mFilter"
                id="mobile-filter-level2"
                class="flex flex-column flex-justify-sb mobile-filter"
                :class="{ 'mobile-filter--open': !!level2mFilter }"
            >
                <div class="mobile-filter__wrap">
                    <div
                        class="flex flex-justify-sb flex-align-center mobile-filter__header"
                    >
                        <button
                            type="button"
                            class="mobile-filter__back-btn"
                            @click="level2mFilter = false"
                        ></button>
                        <div class="h3 mobile-filter__title">
                            {{ filter[level2mFilter].title }}
                        </div>
                        <div></div>
                    </div>

                    <ul class="mobile-filter__list">
                        <!-- {{ this[filter[level2mFilter].srcName] }} -->
                        <!-- eslint-disable -->
                        <li
                            v-for="(item, i) in this[
                                filter[level2mFilter].srcName
                            ]"
                            :key="i"
                            class="mobile-filter__list-item"
                        >
                            <label class="custom-checkbox"
                            >{{ item[filter[level2mFilter].srcKeyTitle] }}
                                <input
                                    v-model="filter[level2mFilter].value"
                                    type="checkbox"
                                    :value="
                                        item[filter[level2mFilter].srcKeyVal]
                                    "
                                    @change="onFilterChange(level2mFilter)"
                                />
                                <span class="custom-checkbox__checkmark"></span>
                            </label>
                        </li>
                        <!-- eslint-enable -->
                    </ul>
                </div>

                <div class="d-flex p-3 mobile-filter__footer">
                    <button
                        type="button"
                        class="cabinet-btn mr-3"
                        @click="closeAllmFilters"
                    >
                        Показать
                    </button>
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        @click="resetFilters()"
                    >
                        Сбросить
                    </button>
                </div>
            </div>
        </section>

        <template v-if="catalogMode == 'products'">
            <products-loading v-if="loading" />
            <div v-else-if="errors.getProducts">
                <div class="error text-center">
                    <div class="error-image">
                        <img src="/img/icons/error.svg" alt="" />
                    </div>
                    <div class="error-title">
                        Упс! Что-то пошло не так.
                    </div>
                    <div class="error-button">
                        <button
                            type="button"
                            class="cabinet-btn"
                            @click="tryLoadingProducts"
                        >
                            Попробовать еще раз
                        </button>
                    </div>
                </div>
            </div>
            <div
                v-else-if="!paginatedProducts.length"
                class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
            >
                <img
                    v-if="searchText.length === 0"
                    src="/img/icons/empty-goods.svg"
                    class="dashboard-empty__img ofi"
                />
                <img
                    v-else
                    src="/img/icons/empty-search.svg"
                    class="dashboard-empty__img dashboard-empty__img--search ofi"
                />
                <div class="dashboard-empty__title pt-5">
                    {{
                        searchText || !isAllDefaultValues
                            ? ' По вашему запросу ничего не найдено.'
                            : 'У вас пока что нет ни одного изделия.'
                    }}
                </div>
            </div>

            <div v-show="!loading && paginatedProducts.length">
                <section class="cabinet-table-options-wrap mb-0">
                    <div
                        class="cabinet-table-options flex flex-align-center pt-0 pb-0"
                    >
                        <div class="d-none d-md-block">
                            {{
                                pagination.page * pagination.pageSize +
                                    1 -
                                    pagination.pageSize
                            }}
                            -
                            {{
                                Math.min(
                                    pagination.page * pagination.pageSize,
                                    pagination.totalProducts
                                )
                            }}

                            из {{ pagination.totalProducts }}
                        </div>

                        <div
                            class="cabinet-table-options__sort flex flex-align-center ml-md-auto"
                        >
                            <div
                                class="dropdown bootstrap-select select select--small cabinet__catalog-select mr-2"
                            >
                                <select-picker
                                    :current-value="sort"
                                    :options="sortVariations"
                                    key-value="value"
                                    key-title="title"
                                    select-width="176"
                                    :classes="['select']"
                                    @onChange="onSortChange($event)"
                                />
                            </div>
                            <template v-if="showViews">
                                <button
                                    type="button"
                                    class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--small cabinet-btn-icon--view ml-auto"
                                    :class="{
                                        active:
                                            catalogMode === 'products' &&
                                            view === 'grid'
                                    }"
                                    @click="changeListView('grid')"
                                ></button>
                                <button
                                    type="button"
                                    class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--small cabinet-btn--view-list d-none d-lg-block"
                                    :class="{
                                        active:
                                            catalogMode === 'products' &&
                                            view === 'list'
                                    }"
                                    @click="changeListView('list')"
                                ></button>
                                <button
                                    v-if="filter.garnitures.value.length"
                                    type="button"
                                    class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--small cabinet-btn-icon--garniture"
                                    :class="{
                                        active: catalogMode === 'garnitures'
                                    }"
                                    @click="toggleCatalogMode('garnitures')"
                                ></button>
                            </template>
                        </div>
                    </div>

                    <section
                        class="cabinet-table-options flex flex-justify-sb flex-align-center d-flex"
                    >
                        <div class="d-none d-md-block">
                            <select-picker
                                :current-value="pagination.pageSize"
                                :options="pageSizesObj"
                                key-value="id"
                                key-title="title"
                                select-width="80"
                                :classes="['select', 'select--small']"
                                @onChange="onPageSizeChange($event)"
                            />
                        </div>
                        <div class="d-md-none">
                            {{
                                Math.min(
                                    pagination.page * pagination.pageSize,
                                    pagination.totalProducts
                                )
                            }}

                            из {{ pagination.totalProducts }}
                        </div>

                        <div class="d-none d-md-flex">
                            <table-pagination
                                :current-page="pagination.page"
                                :total-pages="pagination.totalPages"
                                :total-products="pagination.totalProducts"
                                :disable-scroll-top="isMobile"
                                @setPage="onSetPage($event)"
                            />
                        </div>
                    </section>
                </section>

                <section
                    class="d-flex flex-wrap justify-content-between"
                    :class="{
                        'cabinet__catalog--table': view === 'list',
                        'cabinet__catalog-container': view === 'grid'
                    }"
                >
                    <retailer-product-item
                        v-for="product in paginatedProducts"
                        :key="product.ItemID"
                        :product="product"
                        :list="lists ? lists[0] : undefined"
                        :for-list="forList"
                        show-access
                        @openRequestAccessModal="openRequestAccessModal"
                    />

                    <!-- Костыль для верстки -->
                    <div class="cabinet__catalog-item"></div>
                    <div class="cabinet__catalog-item"></div>
                    <div class="cabinet__catalog-item"></div>
                </section>

                <section
                    class="cabinet-table-options flex flex-justify-sb flex-align-center d-none d-md-flex"
                >
                    <select-picker
                        :current-value="pagination.pageSize"
                        :options="pageSizesObj"
                        key-value="id"
                        key-title="title"
                        select-width="80"
                        :classes="['select', 'select--small']"
                        @onChange="onPageSizeChange($event)"
                    />

                    <table-pagination
                        :current-page="pagination.page"
                        :total-pages="pagination.totalPages"
                        :total-products="pagination.totalProducts"
                        :disable-scroll-top="isMobile"
                        @setPage="onSetPage($event)"
                    />
                </section>

                <section
                    v-if="pagination.page < pagination.totalPages"
                    class="flex flex-column flex-align-center pb-4 d-md-none"
                >
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        :disabled="pagination.page >= pagination.totalPages"
                        @click="updateProductsList(pagination.page + 1, true)"
                    >
                        Загрузить еще
                    </button>
                </section>
            </div>

            <request-access-modal
                :is-open="isOpenRequestAccessBrandModal"
                :brand="requestAccessBrand"
                @onConfirm="sendBrandAccessRequest"
                @onClose="closeRequestAccessModal"
            />
        </template>

        <template v-if="catalogMode == 'garnitures'">
            <div v-if="errors.getProducts">
                <div class="error text-center">
                    <div class="error-image">
                        <img src="/img/icons/error.svg" alt="" />
                    </div>
                    <div class="error-title">
                        Упс! Что-то пошло не так.
                    </div>
                    <div class="error-button">
                        <button
                            type="button"
                            class="cabinet-btn"
                            @click="tryLoadingProducts"
                        >
                            Попробовать еще раз
                        </button>
                    </div>
                </div>
            </div>
            <catalog-garnitures-list
                :page-sizes="pageSizes"
                :filter="filter"
                :search-text="searchText"
                :filter-time-stamp="garnituresFilterTimeStamp"
                @toggleCatalogMode="toggleCatalogMode"
                @changeListView="changeListView"
            />
        </template>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import ClickOutside from 'vue-click-outside'

import getNameById from '@/mixins/getNameById'
import checkDemoUser from '@/mixins/checkDemoUser.js'
import RetailerProductItem from '@/components/Cabinet/Retailer/ProductItem'
import SelectPicker from '@/components/Elements/SelectPicker'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import initSelectPicker from '@/mixins/initSelectPicker'
import onResize from '@/mixins/on-resize'
import RequestAccessModal from '@/components/Cabinet/Retailer/Brands/RequestAccessModal'
import CatalogGarnituresList from '@/components/Cabinet/Retailer/Catalog/GarnituresList'
import FiltersLoading from '@/components/Cabinet/Retailer/Loading/FiltersLoading'
import ProductsLoading from '@/components/Cabinet/Retailer/Loading/ProductsLoading'

export default {
    name: 'RetailerProductList',
    components: {
        RetailerProductItem,
        SelectPicker,
        TablePagination,
        RequestAccessModal,
        CatalogGarnituresList,
        FiltersLoading,
        ProductsLoading
    },
    directives: {
        ClickOutside
    },
    mixins: [initSelectPicker, getNameById, checkDemoUser, onResize],
    props: {
        search: {
            type: String,
            default: ''
        },
        category: {
            type: String,
            default: ''
        },
        collection: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        forList: {
            type: Boolean,
            default: false
        },
        showViews: {
            type: Boolean,
            default: true
        },
        lists: {
            type: Array,
            default: undefined
        },
        pageSizes: {
            type: Array,
            default: () => [10, 20, 50, 100]
        }
    },
    data() {
        return {
            searchText: '',
            view: 'grid',
            sortVariations: [
                {
                    value: 'New:dsc',
                    title: 'Сначала новинки'
                },
                {
                    value: 'Price:asc',
                    title: 'По цене ↑'
                },
                {
                    value: 'Price:dsc',
                    title: 'По цене ↓'
                },
                {
                    value: 'Weight:asc',
                    title: 'По весу ↑'
                },
                {
                    value: 'Weight:dsc',
                    title: 'По весу ↓'
                },
                {
                    value: 'Article:dsc',
                    title: 'По артикулу ↑'
                },
                {
                    value: 'Article:asc',
                    title: 'По артикулу ↓'
                }
            ],
            garnituresOpts: [
                {
                    id: 1,
                    title: 'Входит в гарнитур'
                }
            ],
            filter: {
                categories: {
                    title: 'Категория',
                    srcName: 'categories', //name of store arr
                    srcKeyVal: 'CategoryID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'categoriesValuesArr',
                    isDefault: true, //если default, то параметры не отправляются в запрос
                    apiFilterName: 'categories'
                },
                types: {
                    title: 'Вид изделия',
                    srcName: 'typesByCategories',
                    srcKeyVal: 'TypeID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'typesValuesArr',
                    isDefault: true,
                    apiFilterName: 'types'
                },
                materials: {
                    title: 'Материал',
                    srcName: 'materials',
                    srcKeyVal: 'MaterialID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'materialsValuesArr',
                    isDefault: true,
                    apiFilterName: 'materials'
                },
                finenesses: {
                    title: 'Проба',
                    srcName: 'finenessesByMaterials',
                    srcKeyVal: 'FinenessID',
                    srcKeyTitle: 'Value',
                    value: [],
                    defaultValArrName: 'finenessesValuesArr',
                    isDefault: true,
                    apiFilterName: 'finenesses'
                },
                insertMaterials: {
                    title: 'Материал вставки',
                    srcName: 'insertMaterials',
                    srcKeyVal: 'MaterialID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'insertMaterialsValuesArr',
                    isDefault: true,
                    apiFilterName: 'inserts_materials'
                },
                collections: {
                    title: 'Коллекция',
                    srcName: 'collectionsByBrand',
                    srcKeyVal: 'CollectionID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'collectionsValuesArr',
                    isDefault: true,
                    apiFilterName: 'collections'
                },
                brands: {
                    title: 'Бренд',
                    srcName: 'brands',
                    srcKeyVal: 'BrandID',
                    srcKeyTitle: 'BrandName',
                    value: [],
                    defaultValArrName: 'brandsValuesArr',
                    isDefault: true,
                    apiFilterName: 'brands'
                },
                garnitures: {
                    title: 'Гарнитур',
                    srcName: 'garnituresOpts',
                    srcKeyVal: 'id',
                    srcKeyTitle: 'title',
                    value: [],
                    defaultValArrName: '',
                    isDefault: true,
                    apiFilterName: 'only_has_sets'
                },
                genders: {
                    title: 'Для кого',
                    srcName: 'genders',
                    srcKeyVal: 'id',
                    srcKeyTitle: 'title',
                    value: [],
                    defaultValArrName: '',
                    isDefault: true,
                    apiFilterName: 'genders'
                }
            },
            level1mFilter: false,
            level2mFilter: false,
            loading: true,
            filtersLoading: true,
            isOpenRequestAccessBrandModal: false,
            requestAccessBrand: null,
            catalogMode: 'products', //'garnitures'
            garnituresFilterTimeStamp: ''
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('retailerProducts', [
            'errors',
            'products',
            'mobileProducts',
            'pagination',
            'sort'
        ]),
        ...mapState('categories', { categories: 'supplierCategories' }),
        ...mapGetters('categories', {
            categoriesValuesArr: 'supplierCategoriesValuesArr'
        }),
        ...mapState('collections', { collections: 'supplierCollections' }),
        ...mapGetters('collections', {
            getCollectionsByBrand: 'getSupplierCollectionsByBrand',
            collectionsValuesArr: 'supplierCollectionsValuesArr'
        }),
        ...mapState('types', { types: 'supplierTypes' }),
        ...mapGetters('types', {
            getTypesByCategories: 'getSupplierTypesByCategories',
            typesValuesArr: 'supplierTypesValuesArr'
        }),
        ...mapState('materials', { materials: 'supplierMaterials' }),
        ...mapGetters('materials', {
            materialsValuesArr: 'supplierMaterialsValuesArr'
        }),
        ...mapState('finenesses', { finenesses: 'supplierFinenesses' }),
        ...mapGetters('finenesses', {
            getFinenessesByMaterials: 'getSupplierFinenessesByMaterials',
            finenessesValuesArr: 'supplierFinenessesValuesArr',
            getFinenessesNamesArr: 'getSupplierFinenessesNamesArr'
        }),
        ...mapState('insert', { insertMaterials: 'supplierInsertMaterials' }),
        ...mapGetters('insert', {
            insertMaterialsValuesArr: 'supplierInsertMaterialsValuesArr'
        }),
        ...mapState('purposes', ['purposes']),
        ...mapState('genders', { genders: 'userGenders' }),
        ...mapGetters('brands', ['brands', 'brandsValuesArr']),
        pageSizesObj() {
            return this.pageSizes.map(item => ({
                id: item,
                title: item
            }))
        },
        typesByCategories() {
            return this.getTypesByCategories(this.filter.categories.value)
        },
        collectionsByBrand() {
            return this.getCollectionsByBrand(this.filter.brands.value)
        },
        finenessesByMaterials() {
            return this.getFinenessesByMaterials(this.filter.materials.value)
        },
        finenessesNamesArr() {
            return this.getFinenessesNamesArr(this.filter.finenesses.value)
        },
        isAllDefaultValues() {
            return (
                Object.keys(this.filter).filter(
                    item => !this.filter[item].isDefault
                ).length === 0
            )
        },
        appliedFiltersCount() {
            return Object.keys(this.filter).filter(
                item => this.filter[item].value.length
            ).length
        },
        paginatedProducts() {
            if (document.documentElement.clientWidth > 767) {
                return this.products
            }
            return this.mobileProducts
        },
        //если выбрана категория украшения
        isCategoryDecoration() {
            return (
                this.filter.categories.value.length == 1 &&
                this.filter.categories.value[0] == 1
            )
        }
    },
    watch: {
        wwidth: function(val) {
            if (this.view === 'list' && val < 1024) {
                this.view = 'grid'
            }
        },
        isCategoryDecoration: function(val) {
            if (!val) {
                if (this.catalogMode == 'garnitures') {
                    this.toggleCatalogMode('products')
                }

                this.filter.garnitures.value = []
                this.filter.garnitures.isDefault = true
            }
        }
    },
    created() {
        this.searchText = this.search
        this.setPreset()
    },
    async mounted() {
        if (this.catalogMode == 'products') {
            if (
                this.isAllDefaultValues &&
                !this.searchText &&
                this.pagination.page === 1
            ) {
                await this.updateProductsListFunc(1)
            } else {
                await this.updateProductsList(this.pagination.page, true)
            }
        }

        this.getLists()
        this.setFilters()
    },
    async destroyed() {
        this.clearProducts()
    },
    methods: {
        ...mapMutations('retailerProducts', ['SET_PAGINATION']),
        ...mapActions('retailerProducts', [
            'setSort',
            'setPagination',
            'getProducts',
            'clearProducts'
        ]),
        ...mapActions('retailerBrand', ['requestAccessToBrand']),
        ...mapActions('retailerLists', ['getLists']),
        ...mapActions('categories', ['getCategories']),
        ...mapActions('types', ['getTypes']),
        ...mapActions('materials', ['getMaterials']),
        ...mapActions('finenesses', ['getFineness']),
        ...mapActions('purposes', ['getPurposes']),
        ...mapActions('genders', ['getGenders']),
        ...mapActions('insert', ['getInsertMaterials']),
        ...mapActions('collections', ['getCollections']),
        ...mapActions('brands', ['getBrands']),
        onSelectPickerChange(type, val) {
            this.filter[type].value = val
            this.onFilterChange(type)
        },
        async tryLoadingProducts() {
            this.loading = true
            if (this.catalogMode == 'products') {
                if (
                    this.isAllDefaultValues &&
                    !this.searchText &&
                    this.pagination.page === 1
                ) {
                    await this.updateProductsListFunc(1)
                } else {
                    await this.updateProductsList(this.pagination.page, true)
                }
            }

            this.getLists()
            this.setFilters()
        },
        setPreset() {
            const preset = localStorage.getItem('retailer-catalog-data')

            if (preset) {
                const {
                    filter,
                    view,
                    searchText,
                    pagination,
                    sort
                } = JSON.parse(preset)

                this.filter = filter
                this.view = view
                this.searchText = searchText
                this.setPagination(pagination)
                this.setSort(sort)
            }

            if (this.category) {
                this.filter.categories.value = [this.category]
                this.filter.categories.isDefault = false
            }

            if (this.collection) {
                this.filter.collections.value = [this.collection]
                this.filter.collections.isDefault = false
            }

            if (this.type) {
                this.filter.types.value = [this.type]
                this.filter.types.isDefault = false
            }
        },
        setFilters() {
            const filtersQueries = []

            filtersQueries.push(
                this.getCategories({ existing: true, sort_by: 'Position' })
            )

            filtersQueries.push(this.getTypes({ existing: true }))

            filtersQueries.push(this.getMaterials({ existing: true }))

            if (!this.finenesses.length) {
                filtersQueries.push(this.getFineness({ existing: true }))
            }

            filtersQueries.push(this.getInsertMaterials({ existing: true }))

            filtersQueries.push(this.getBrands({ existing: true }))

            filtersQueries.push(
                // eslint-disable-next-line
                this.getCollections({ existing: true })
            )

            this.getGenders({ existing: true })

            return Promise.all(filtersQueries).then(() => {
                this.filtersLoading = false
            })
        },
        setlevel2mFilters(filterKey) {
            this.level2mFilter = filterKey
        },
        changeListView(type) {
            this.view = type
            if (this.catalogMode !== 'products') {
                this.toggleCatalogMode('products')
            }
        },
        resetFilters() {
            Object.keys(this.filter).forEach(item => {
                this.filter[item].value = []
            })

            Object.keys(this.filter).forEach(
                item => (this.filter[item].isDefault = true)
            )

            this.closeAllmFilters()

            switch (this.catalogMode) {
                case 'products':
                    this.updateProductsList(1)
                    break
                case 'garnitures':
                    this.handleUpdateGarnituresList()
                    break
            }
        },
        closeAllmFilters() {
            this.level2mFilter = false
            this.level1mFilter = false
        },
        getNameById_old(filterKey, filterValue) {
            const src = this[this.filter[filterKey].srcName]

            const item = src.find(el => {
                if (el[this.filter[filterKey].srcKeyVal] == filterValue) {
                    return el
                }
            })

            if (item) return item[this.filter[filterKey].srcKeyTitle]
            return ''
        },
        onFilterChange(filterType) {
            this.filter[filterType].isDefault = !this.filter[filterType].value
                .length

            if (filterType === 'garnitures') {
                if (this.filter.garnitures.value.length) {
                    this.setSort('Article:asc')
                } else if (this.sort === 'Article:asc') {
                    this.setSort('New:dsc')
                }
            }

            if (filterType === 'brands') {
                this.filter.collections.value = [
                    ...this.filter.collections.value
                ].filter(val =>
                    this.collectionsByBrand.some(
                        item => item.CollectionID === val
                    )
                )
                this.filter.collections.isDefault = true
            }

            switch (this.catalogMode) {
                case 'products':
                    this.updateProductsList(1)
                    break
                case 'garnitures':
                    this.handleUpdateGarnituresList()
                    break
            }
        },
        updateProductsList: _.debounce(function(
            page = 1,
            isMobilePagination = false
        ) {
            this.updateProductsListFunc(page, isMobilePagination)
        },
        800),
        async updateProductsListFunc(page = 1, isMobilePagination = false) {
            this.$Progress.start()

            const data = {
                page,
                sort_by: this.sort.split(':')[0],
                sort_type: this.sort.split(':')[1],
                isMobilePagination
            }

            Object.keys(this.filter).forEach(item => {
                if (!this.filter[item].isDefault) {
                    let valuesArr = [...this.filter[item].value]

                    if (item === 'finenesses') {
                        valuesArr = [...this.finenessesNamesArr]
                    }

                    if (!valuesArr.length) {
                        valuesArr = [null]
                    }

                    data[this.filter[item].apiFilterName] = valuesArr
                }
            })

            if (this.searchText) {
                data.search = this.searchText
            }

            if (this.lists) {
                data.lists = this.lists
            }

            await this.getProducts(data)

            this.loading = false
        },
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.updateProductsList(page)
        },
        onPageSizeChange(val) {
            this.SET_PAGINATION({
                key: 'pageSize',
                val
            })

            this.updateProductsList(1)
        },

        onSearch() {
            this.$Progress.start()
            switch (this.catalogMode) {
                case 'products':
                    this.updateProductsList(1)
                    break
                case 'garnitures':
                    this.handleUpdateGarnituresList()
                    break
            }
        },
        onClearSearch() {
            this.searchText = ''
            this.$Progress.start()
            switch (this.catalogMode) {
                case 'products':
                    this.updateProductsList(1)
                    break
                case 'garnitures':
                    this.handleUpdateGarnituresList()
                    break
            }
        },
        onSortChange(value) {
            this.setSort(value)

            this.updateProductsList(1)
        },
        openRequestAccessModal(brand) {
            this.isOpenRequestAccessBrandModal = true
            this.requestAccessBrand = brand
        },
        closeRequestAccessModal() {
            this.isOpenRequestAccessBrandModal = false
            this.requestAccessBrand = null
        },
        sendBrandAccessRequest(brand) {
            if (this.isDemoUserMode()) return

            this.requestAccessToBrand(brand.BrandID).then(() => {
                this.$notify({
                    type: 'success',
                    text: `Запрос доступа к скрытым изделиям бренда “${brand.BrandName}” отправлены`
                })

                this.updateProductsList(this.pagination.page)
                this.closeRequestAccessModal()
            })
        },
        toggleCatalogMode(val) {
            this.catalogMode = val
            if (val == 'products') {
                this.loading = true
                this.clearProducts()
                this.updateProductsList(1)
            }
        },
        handleUpdateGarnituresList() {
            this.garnituresFilterTimeStamp = '' + Date.now()
        }
    }
}
</script>
